import PageComponent from '../base/PageComponent';

export default class Pager extends PageComponent {
    constructor(element, parent) {
        super(element);
        this.parent = parent;
    }

    init() {
        this.addEvent('.prev', 'click', e => this.updateListing(e));
        this.addEvent('.next', 'click', e => this.updateListing(e));
    }

    updateListing(e){
        e.preventDefault();

        this.parent.addSpinner();

        let url = e.target.getAttribute('href'),
            headers = new Headers();

        headers.append("X-Requested-With", "XMLHttpRequest");

        fetch(url, {
            method: 'GET',
            headers: headers,
        }).then(response => {
            return response.json();
        }).then(json => {
            this.parent.updateModuleViews(json);
        });
    }
}


// WEBPACK FOOTER //
// ./javascript/modules/PropertyListingPager.js